module.exports = __webpack_public_path__ + "static/media/sliders-v-square.79c9677d.svg";